module.exports = __webpack_public_path__ + "media/masonic_lodge.1dbc00f3.wav";